import type { Company } from '~/types'
import {
  CurrencyGhanaCode,
  CurrencyKenyaCode,
  CurrencyNairaCode,
  CurrencyUSDCode,
} from '~/constants'

export function getAvailableCurrenciesForCompany(company: Company) {
  const integratedCurrencies = new Set<string>()

  if (company?.payment_keys?.has_flutterwave_key) {
    integratedCurrencies
      .add(CurrencyNairaCode)
      .add(CurrencyGhanaCode)
      .add(CurrencyKenyaCode)
      .add(CurrencyUSDCode)
  }
  if (company?.payment_keys?.has_paystack_key) {
    integratedCurrencies
      .add(CurrencyNairaCode)
      .add(CurrencyGhanaCode)
      .add(CurrencyUSDCode)
  }

  return Array.from(integratedCurrencies.values())
}
